<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<h2 class="fm_title"><span class="bold">List of Illustrations</span></h2>
<h2 class="sub-section"><span class="bold">Front cover</span></h2>
<p class="noindent">William Maitland of Lethington, Mary’s Secretary of State, whose doubtful loyalty caused him to be dubbed the ‘chameleon’ by George Buchanan. (Oil on panel / Lennoxlove House Limited / scran.ac.uk / 000-000-027-976-R)</p>
<h2 class="sub-section"><span class="bold">Picture section</span></h2>
<table class="table1">
<tbody><tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates01" title="Link target outside of Sample">Sir John Maitland of Thirlestane</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates01" title="Link target outside of Sample">1</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates02" title="Link target outside of Sample">Lethington House (now Lennoxlove)</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates02" title="Link target outside of Sample">1</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates03" title="Link target outside of Sample">Mary Queen of Scots</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates03" title="Link target outside of Sample">2</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates04" title="Link target outside of Sample">Mary of Guise</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates04" title="Link target outside of Sample">2</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates05" title="Link target outside of Sample">Lord James Stewart (later Earl of Moray)</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates05" title="Link target outside of Sample">2</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates06" title="Link target outside of Sample">David Riccio</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates06" title="Link target outside of Sample">3</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates07" title="Link target outside of Sample">Palace of Holyrood House</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates07" title="Link target outside of Sample">3</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates08" title="Link target outside of Sample">Henry Stuart, Lord Darnley</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates08" title="Link target outside of Sample">4</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates09" title="Link target outside of Sample">Craigmillar Castle</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates09" title="Link target outside of Sample">4</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates10" title="Link target outside of Sample">James Douglas, 4th Earl of Morton</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates10" title="Link target outside of Sample">5</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates11" title="Link target outside of Sample">Lochleven Castle</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates11" title="Link target outside of Sample">5</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates12" title="Link target outside of Sample">Matthew Stuart, 4th Earl of Lennox</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates12" title="Link target outside of Sample">6</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates13" title="Link target outside of Sample">Stirling Castle</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates13" title="Link target outside of Sample">6</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates14" title="Link target outside of Sample">James Hepburn,4th Earl of Bothwell</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates14" title="Link target outside of Sample">7</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates15" title="Link target outside of Sample">Robert Dudley, Earl of Leicester</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates15" title="Link target outside of Sample">7</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates16" title="Link target outside of Sample">Thomas Howard, 4th Duke of Norfolk</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates16" title="Link target outside of Sample">7</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates17" title="Link target outside of Sample">Elizabeth I</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates17" title="Link target outside of Sample">8</span></td>
</tr>
<tr>
<td class="tab101"><span href="#/xhtml/39_Plates#plates18" title="Link target outside of Sample">William Cecil, Lord Burghley</span></td>
<td class="tab102"><span href="#/xhtml/39_Plates#plates18" title="Link target outside of Sample">8</span></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_ListofIllustration.vue?adf96b3c